var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionSoftwareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27595",
    "data-name": "Group 27595",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.693,
    height: 23.769,
    viewBox: "0 0 32.693 23.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8991",
    "data-name": "Group 8991",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M105.288,569.9l1.01-4.168-5.281-.236,8.542-7.392-1.475-.157,1.475-5.819h4.815l3.339,4.011,5.9-4.011h5.9l-.777,3.617,4.97.157-8.7,7.628,1.4.236-1.242,6.134h-5.591l1.32-6.291-5.2,3.853-3.106-3.853-1.553,6.291Z",
    transform: "translate(-101.017 -552.129)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8992",
    "data-name": "Group 8992",
    transform: "translate(0.322 21.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10217",
    "data-name": "Path 10217",
    d: "M171.326,320.873h.476l.3.882.777-.882h.53l-.56,2.085h-.464l.363-1.362-.816.891h-.012l-.334-.882-.363,1.353h-.459Z",
    transform: "translate(-170.766 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10218",
    "data-name": "Path 10218",
    d: "M195.9,321.784a1.245,1.245,0,0,1,1.254-1.233.9.9,0,0,1,.954.923,1.246,1.246,0,0,1-1.255,1.234A.9.9,0,0,1,195.9,321.784Zm1.731-.28a.493.493,0,0,0-.53-.53.773.773,0,0,0-.724.78.493.493,0,0,0,.53.53A.773.773,0,0,0,197.631,321.5Z",
    transform: "translate(-193.113 -320.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10219",
    "data-name": "Path 10219",
    d: "M218.523,321.3h-.635l.114-.423h1.728l-.114.423h-.634l-.447,1.662h-.459Z",
    transform: "translate(-212.663 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10220",
    "data-name": "Path 10220",
    d: "M233.375,320.873h.459l-.56,2.085h-.459Z",
    transform: "translate(-225.935 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10221",
    "data-name": "Path 10221",
    d: "M243.474,321.784a1.245,1.245,0,0,1,1.254-1.233.9.9,0,0,1,.953.923,1.246,1.246,0,0,1-1.254,1.234A.9.9,0,0,1,243.474,321.784Zm1.731-.28a.493.493,0,0,0-.531-.53.773.773,0,0,0-.723.78.492.492,0,0,0,.53.53A.773.773,0,0,0,245.2,321.5Z",
    transform: "translate(-235.412 -320.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10222",
    "data-name": "Path 10222",
    d: "M265.244,320.873h.423l.607,1.326.358-1.326h.453l-.56,2.085h-.39l-.631-1.368-.366,1.368h-.453Z",
    transform: "translate(-254.27 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10223",
    "data-name": "Path 10223",
    d: "M289.468,322.351l.179-.14a.818.818,0,0,0,.688.325c.3,0,.527-.164.527-.391,0-.16-.107-.256-.429-.381-.384-.152-.572-.286-.572-.557,0-.345.319-.6.768-.6a.955.955,0,0,1,.739.316l-.173.155a.756.756,0,0,0-.587-.259c-.313,0-.5.176-.5.366,0,.17.134.256.462.384.357.137.539.283.539.551a.708.708,0,0,1-.789.632A1,1,0,0,1,289.468,322.351Z",
    transform: "translate(-276.306 -320.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10224",
    "data-name": "Path 10224",
    d: "M309.562,321.805a1.256,1.256,0,0,1,1.215-1.254.883.883,0,0,1,.915.9,1.257,1.257,0,0,1-1.215,1.257A.884.884,0,0,1,309.562,321.805Zm1.883-.342a.658.658,0,0,0-.682-.694,1.015,1.015,0,0,0-.954,1.031.659.659,0,0,0,.683.694A1.014,1.014,0,0,0,311.445,321.463Z",
    transform: "translate(-294.172 -320.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10225",
    "data-name": "Path 10225",
    d: "M332.522,320.873h1.5l-.056.217H332.7l-.2.745h1.132l-.06.215h-1.129l-.245.909h-.235Z",
    transform: "translate(-314.089 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10226",
    "data-name": "Path 10226",
    d: "M354.312,321.09h-.7l.059-.217h1.642l-.059.217h-.7l-.5,1.868h-.236Z",
    transform: "translate(-333.335 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10227",
    "data-name": "Path 10227",
    d: "M371.956,320.823h.244l.131,1.737,1.034-1.743h.193l.11,1.743,1.061-1.737h.265l-1.308,2.1h-.205l-.119-1.683-1.022,1.683h-.2Z",
    transform: "translate(-349.648 -320.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228",
    "data-name": "Path 10228",
    d: "M397.411,320.736h-.227l-1.513,2.1h.259l1.3-1.832.322,1.832h.241Z",
    transform: "translate(-370.734 -320.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229",
    "data-name": "Path 10229",
    d: "M421.366,321.424a.507.507,0,0,0-.137-.36.813.813,0,0,0-.587-.19h-.751l-.56,2.085h.235l.5-1.868h.56a.556.556,0,0,1,.408.125.315.315,0,0,1,.087.227.422.422,0,0,1-.125.3.828.828,0,0,1-.593.191h-.357l-.055.211h.356l.411.81h.271l-.429-.835a1.012,1.012,0,0,0,.578-.247A.631.631,0,0,0,421.366,321.424Z",
    transform: "translate(-391.77 -320.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10230",
    "data-name": "Path 10230",
    d: "M440.493,320.873h1.492l-.059.214h-1.257l-.19.712H441.6l-.06.214h-1.12l-.2.73H441.5l-.057.215h-1.507Z",
    transform: "translate(-410.088 -320.837)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionSoftwareLogo);
export default __webpack_public_path__ + "static/media/motion-software-logo.8376fd863e9f5d694fb2a4d4ccb512e9.svg";
export { ForwardRef as ReactComponent };